module.exports = __webpack_public_path__ + "media/images/icons/icons_large/17_arc-bc2eaf36aa5d12cb76d9815baee58115.png";